import { useState, useRef, useEffect } from "react";

interface Props {
  fileName: string;
  data: any[];
  columns: { key: string; label: string }[];
}

export default function AdminExport({ fileName, data, columns }: Props) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePrint = () => {
    window.print();
  };

  const handleCSV = () => {
    const csvContent = [
      columns.map((col) => col.label).join(","),
      ...data.map((row) =>
        columns.map((col) => `"${row[col.key] ?? ""}"`).join(","),
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.csv`;
    a.click();

    setOpen(false);
  };

  const handleExcel = () => {
    alert("Excel logic here");
    setOpen(false);
  };

  const handlePDF = () => {
    alert("PDF logic here");
    setOpen(false);
  };

  return (
    <div className="admin-export-wrapper" ref={dropdownRef}>
      {/* Export Dropdown */}
      <div className="admin-export-dropdown">
        <button className="btn-export" onClick={() => setOpen(!open)}>
          Export ▾
        </button>

        {open && (
          <div className="export-menu">
            <button onClick={handleCSV}>CSV</button>
            <button onClick={handleExcel}>Excel</button>
            <button onClick={handlePDF}>PDF</button>
          </div>
        )}
      </div>

      {/* Print Button Separate */}
      <button className="btn-print" onClick={handlePrint}>
        Print
      </button>
    </div>
  );
}
